import * as React from 'react';
import { AddressDTO, Res } from 'core/api';
import { Result } from 'core/infrastructure';
import * as UI from 'core/ui';
import * as Images from 'pos/Images';

import { ActionButtonDefinition, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import { CustomerFacade } from 'pos/facades';
import { Modal } from 'core/ui-next/modal';

type Props = Modal.Actions<AddressDTO>
type State = AddressDTO;

class DeliveryAddressScreen extends PosScreenClassComponent<Props, State> {

	private form = React.createRef<UI.Form<State>>();

	protected getScreenId(): string {
		return 'CREATE_DELIVERY_ADDRESS';
	}

	protected getTitle(): string {
		return Res.Web.CREATE_DELIVERY_ADDRESS();
	}

	protected getImage(): string | SvgIcon {
		return Images.Address;
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {

		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			this.okButton(this.accept)
		];
	}

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}

	protected useKeypad() {
		return false;
	}

	private accept = async () => {
		const updated = await this.form.current!.updateModel();
		if (updated)
			this.close(this.state);
	};

	createInitialState(_props: Props): Nullable<State> {
		return {
			City: '',
			Street: '',
			Region: '',
			ZipCode: ''
		};
	}

	protected getContent(): React.ReactNode {
		const { Form, TextBox } = UI.controlsFor<State>();

		return <Form small ref={this.form} model={this.state}>
			<TextBox linkTo={x => x.Street} label={Res.Web.CREATE_DELIVERY_ADDRESS_STREET_LBL()} required />
			<TextBox linkTo={x => x.ZipCode} label={Res.Web.CREATE_DELIVERY_ADDRESS_ZIP_CODE_LBL()} />
			<TextBox linkTo={x => x.City} label={Res.Web.CREATE_DELIVERY_ADDRESS_CITY_LBL()} />
			<TextBox linkTo={x => x.Region} label={Res.Web.CREATE_DELIVERY_ADDRESS_REGION_LBL()} />
		</Form>;
	}
}

export default async function createDeliveryAddress(customer: { Id: number }): Promise<Result> {
	const result = await Modal.show(DeliveryAddressScreen);
	if (result.ok) {
		await CustomerFacade.addDeliveryAddress(customer.Id, result.value);
	}

	return result.ok ? Result.ok() : Result.error();
}
